var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
  id: "sprout"
}, /*#__PURE__*/React.createElement("rect", {
  x: -0.45,
  y: -3.6,
  width: 0.9,
  height: 3.6,
  fill: "#3f8f4f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0-3.2c-2.6-0.3-4-2-4-4.4 2.6 0.3 4 2 4 4.4z",
  fill: "#57b368"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0-3.2c2.6-0.3 4-2 4-4.4-2.6 0.3-4 2-4 4.4z",
  fill: "#57b368"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m9.6 39.5c-0.8 0-1.4-0.8-1.2-1.6l5.1-17c0.2-0.5 0.6-0.9 1.2-0.9h15.6c0.6 0 1 0.4 1.2 0.9l5.1 17c0.2 0.8-0.4 1.6-1.2 1.6z",
  fill: "#a9713d"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m17.6 39.5 1.6-19.5",
  fill: "none",
  stroke: "#8a5a2e",
  strokeWidth: 1.1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m27.4 39.5-1.6-19.5",
  fill: "none",
  stroke: "#8a5a2e",
  strokeWidth: 1.1
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(13.6 36.8) scale(1.1)"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(22.5 36.8) scale(1.1)"
});

var _ref8 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(31.4 36.8) scale(1.1)"
});

var _ref9 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(15.2 31) scale(0.85)"
});

var _ref10 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(22.5 31) scale(0.85)"
});

var _ref11 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(29.8 31) scale(0.85)"
});

var _ref12 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(16.6 25.6) scale(0.65)"
});

var _ref13 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(22.5 25.6) scale(0.65)"
});

var _ref14 = /*#__PURE__*/React.createElement("use", {
  href: "#sprout",
  transform: "translate(28.4 25.6) scale(0.65)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 30.2,
  y: 11,
  width: 1.3,
  height: 13.5,
  rx: 0.65,
  fill: "#6b4a2b"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m31.5 11 6.6 2.5-6.6 2.5z",
  fill: "#e8923a"
});

function SvgTestField(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestField);
export default __webpack_public_path__ + "static/media/test-field.5b70a1bf0fbbdef130197ef1a966d132.svg";
export { ForwardRef as ReactComponent };